import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";

export default function PrivacyPolicy() {
  return (
    <div>
      <Fixed />
      <div className="min-h-screen py-16 px-6 bg-gradient-to-b from-gray-100 to-gray-300 text-gray-900 pt-32">
        <div className="max-w-5xl mx-auto">
          {/* Page Header */}
          <motion.h1
            className="text-4xl md:text-5xl font-extrabold text-center text-gray-800"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Privacy & Policy
          </motion.h1>
          <p className="text-lg text-center text-gray-600 mt-4 max-w-2xl mx-auto">
            Your privacy is our priority. Read our policies to understand how we protect your data.
          </p>

          {/* Sections */}
          <div className="mt-10 space-y-8">
            {sections.map((section, index) => (
              <motion.div
                key={index}
                className="bg-white border border-gray-200 p-6 md:p-8 shadow-md rounded-xl transition duration-300 hover:shadow-xl"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
                  <span className="bg-blue-600 text-white text-lg px-3 py-1 rounded-md">
                    {index + 1}
                  </span>
                  {section.title}
                </h2>
                <p className="mt-3 text-gray-700 leading-relaxed">{section.content}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
      <Footer1 />
    </div>
  );
}

// Data for the sections
const sections = [
  {
    title: "Information We Collect",
    content:
      "We collect personal information such as your name, email, phone number, and payment details when you use our services, including JCSPay and Electronics Trading.",
  },
  {
    title: "How We Use Your Information",
    content:
      "Your information is used for account setup, transactions, security verification, and improving our services. We do not sell your personal data.",
  },
  {
    title: "Payment Security",
    content:
      "JCSPay ensures secure payment processing with advanced encryption, fraud detection, and compliance with industry standards like PCI DSS.",
  },
  {
    title: "Data Sharing & Third Parties",
    content:
      "We do not share your personal data with third parties except for essential service providers such as payment processors and regulatory authorities.",
  },
  {
    title: "Cookies & Tracking",
    content:
      "We use cookies to enhance user experience, track website traffic, and analyze user behavior. You can disable cookies in your browser settings.",
  },
  {
    title: "Your Rights & Choices",
    content:
      "You have the right to access, update, or delete your data. You can also opt out of marketing communications at any time.",
  },
  {
    title: "Policy Updates",
    content:
      "We may update our Privacy Policy from time to time. Any changes will be communicated on our website.",
  },
  {
    title: "Contact Us",
    content:
      'If you have any questions regarding our privacy policies, feel free to contact us at tech.support@jcsglobal.in.',
  },
];
